import React, { useState } from 'react';
import {motion, easeInOut} from 'framer-motion';

type FadeOutProps = {
  children?: React.ReactNode;
  className?: string;
  animation?: {
    duration?: number;
    delay?: number;
    startOpacity?: number;
    startBackgroundColor?: string;
    endOpacity?: number;
    endBackgroundColor?: string;
  }
  onAnimationComplete?: () => void;
  onAnimationStart?: () => void;
}

function FadeOut({ children, className, animation, onAnimationComplete, onAnimationStart }: FadeOutProps) {
  const variants = {
    hidden: {
      opacity: animation?.startOpacity || 1,
      transition: {
        duration: animation?.duration || 0.5,
        delay: animation?.delay || 0,
        ease: easeInOut,
      },
    },

    visible: {
      opacity: animation?.endOpacity || 0,
      transition: {
        duration: animation?.duration || 0.5,
        delay: animation?.delay || 0,
        ease: easeInOut,
      },
    },

  }

  return (
    <motion.div
      variants={variants}
      initial="hidden"
      animate="visible"
      className={className || ''}
      onAnimationStart={onAnimationStart}
      onAnimationComplete={onAnimationComplete}
    >
      {children}
    </motion.div>
  );
}

export default FadeOut;